module.exports = __webpack_public_path__ + "img/category-management-icon3.e96f07bf.svg";